import apiRequestType from "../apiRequestType";
import { apiTypes } from "../../utils/apiTypes";
import { apiConstants } from "../../utils/apiConstants";

const deleteTopicByID = (dataID) => {
  return apiRequestType(
    apiTypes.DELETE,
    apiConstants.ORGANIZE.DELETE_TOPIC_BY_ID(dataID)
  );
};

export default deleteTopicByID
